<template>
<Box @close="close({})" v-if="orden_pago">
    <template #top>Orden de Pago</template>
    <template #center>
        <div>
            <div class="nj-cols">
                <div class="nj-panel">
                    <div class="nj-panel-content">
                        <div class="nj-subtitle-1">Orden de Pago</div>
                        <div class="nj-cols c3">
                            <Info label="Descripción">{{ orden_pago.opg_descripcion }}</Info>
                            <Info label="Registrado por">{{ orden_pago.opg_creador_nombre }}</Info>
                            <Info label="Aprobado por">{{ orden_pago.opg_aprobador_nombre }}</Info>
                        </div>
                        <div class="nj-cols c3">
                            <Info label="Fecha de registro">{{ orden_pago.opg_fecha_registro }}</Info>
                            <Info label="Fecha de pago programado">{{ orden_pago.opg_fecha_pago_programado }}</Info>
                            <Info label="Fecha de aprobación">{{ orden_pago.opg_fecha_aprobacion }}</Info>
                        </div>
                        <div class="nj-cols c3">
                            <Info label="Monto total">{{ orden_pago.opg_total | money(orden_pago.mon_simbolo) }}</Info>
                            <Info label="Detracción">{{ orden_pago.opg_detraccion | money(orden_pago.mon_simbolo) }}</Info>
                            <Info label="Monto a pagar">{{ orden_pago.opg_pago | money(orden_pago.mon_simbolo) }}</Info>
                        </div>
                        <div class="nj-cols c3">
                            <Info label="Estado">{{ orden_pago.opg_estado }}</Info>
                            <Info label="Cierre">{{ checkCierre(orden_pago.opg_pago_cierre) }}</Info>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>
    <template #bottom>
        <!-- <Upload label="Documento" v-model="pdf"></Upload>
        <Button label="Registrar" icon="save" color="green" @click="registrar()"></Button> -->
        <Button label="Aprobar" icon="save" color="green" @click="aprobar()" :activation="activarAprobar" activationCode="aprobar_orden_pago"></Button>
    </template>
</Box>
</template>

<script>
import { EstadoEnum } from "../../constants"
import { OrdenCompraService, OrdenPagoService, ResponseStatus, UsuarioService } from "../../rest"
import { Confirm } from "../../util"
import Toast from "../../util/toast"
import { Box, Button, Info, InputDate, InputSelect, InputText, InputUpload, Upload } from "../components"
import OrdenCompraData from "./OrdenCompraData.vue"

export default {
    name: "VerOrdenPago",
    components: {
        OrdenCompraData,
        InputText,
        InputSelect,
        InputUpload,
        Button,
        Upload,
        InputDate,
        Box,
        Info,
    },
    props: {
        opg_id: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            ord_id: this.$route.params.ord_id,
            orden_pago: {},
            pago_cierre: 0,
            detraccion: null,
            pdf: null,
        }
    },
    computed: {
        activarAprobar() {
            return this.orden_pago.opg_estado == EstadoEnum.CREADO.est_codigo || this.orden_pago.opg_estado == EstadoEnum.POR_APROBAR.est_codigo
        }
    },
    methods: {
        aprobar() {
            Confirm.show({
                message: "Desea aprobar la orden de pago?",
                action: () => {
                    OrdenPagoService
                        .aprobar({
                            orden_pago: {
                                opg_id: this.opg_id,
                                opg_aprobador: UsuarioService.getUsuario().usu_id,
                            }
                        })
                        .then(response => {
                            if (ResponseStatus.isSuccess(response)) {
                                Toast.success(response.message)
                                this.close({
                                    buscar_ordenes_pago: true,
                                    buscar_datos_orden: true,
                                })
                            }
                            else {
                                Toast.warn(response.message)
                            }
                        })
                        .catch(error => {
                            Toast.error(error)
                        })
                }
            })
        },
        close({
            interfaz = "none",
            buscar_ordenes_pago = false,
            buscar_datos_orden = false,
        }) {
            this.$emit("close", {
                interfaz,
                buscar_ordenes_pago,
                buscar_datos_orden,
            })
        },
        checkCierre(status) {
            return status == 1 ? "SI" : "NO"
        }
    },
    mounted() {
        OrdenPagoService
            .obtener({
                orden_pago: {
                    opg_id: this.opg_id
                }
            })
            .then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.orden_pago = response.data
                    this.pago_cierre = this.orden_pago.opg_pago_cierre == 1 ? "No aplicar cierre" : "Aplicar cierre"
                }
                else {
                    Toast.warn(response.message)
                }
            })
            .catch(error => {
                Toast.error(error)
            })
    },
}
</script>
<style scoped></style>